import { fetch } from '@/plugin/axios/index.js'

export function authLogin(data) {
  return fetch({
    url: '/auth/auth/login',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Login/index.js